module.exports = __webpack_public_path__ + "static/img/coupon_bg.d882a18.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/coupon_bg.png
// module id = xPjK
// module chunks = 6